import * as Yup from 'yup'
import { contact } from './messages'

export default Yup.object().shape({
    email: Yup.string()
        .required(contact.email.required)
        .email(contact.email.invalid),
})
